import { Container } from "./styles";
import cssIcon from "../../assets/css-icon.svg";
import htmlIcon from "../../assets/html-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import gitIcon from "../../assets/git.png";
import figmaIcon from "../../assets/figma.png";
import cIcon from "../../assets/c.png";
import phpIcon from "../../assets/php.png";
import flutterIcon from "../../assets/flutter.png";
import firebaseIcon from "../../assets/firebase.png";
import AboutMe from "../../assets/aboutme.jpg";
import ScrollAnimation from "react-animate-on-scroll";

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
      <ScrollAnimation animateIn="fadeInLeft">
          <h2>About Me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000}>
          <p>
            I'm Flocer Angelo M. Bustamante, a Computer Science graduate from
            Caraga State University, eager to apply my extensive experience in
            developing responsive and scalable software projects.{" "}
          </p>
          </ScrollAnimation>
          <ScrollAnimation
          animateIn="fadeInLeft"
          delay={0.4 * 1000}
          style={{ marginTop: "2rem", marginBottom: "2rem" }}
        >
          <p>
            As a former co-founder of ScrapCycle, a startup recognized in
            regional and national competitions and incubated by Navigatu, I have
            honed teamwork, effective communication, and adaptability skills.{" "}
          </p>
          </ScrollAnimation>
          <ScrollAnimation animateIn="fadeInLeft" delay={0.6 * 1000}>
          <p>
            Combining technical proficiency with a genuine passion for
            delivering exceptional user experiences, I am enthusiastic about
            making a meaningful impact on your company. I am eager to contribute
            to your mission of creating innovative and user-centric software
            solutions.{" "}
          </p>
          </ScrollAnimation>

          <ScrollAnimation animateIn="fadeInLeft" delay={0.7 * 1000}>
          <h3>Here are my main skills: </h3>
        </ScrollAnimation>
          
        <div className="hard-skills">

<div className="hability">
  <ScrollAnimation animateIn="fadeInUp">
    <img src={jsIcon} alt="JavaScript" />
  </ScrollAnimation>
</div>

<div className="hability">
  <ScrollAnimation animateIn="fadeInUp">
    <img src={htmlIcon} alt="Html" />
  </ScrollAnimation>
</div>

<div className="hability">
  <ScrollAnimation animateIn="fadeInUp">
    <img src={cssIcon} alt="Css" />
  </ScrollAnimation>
</div>

<div className="hability">
  <ScrollAnimation animateIn="fadeInUp">
    <img src={cIcon} alt="C" />
  </ScrollAnimation>
</div>

<div className="hability">
  <ScrollAnimation animateIn="fadeInUp">
    <img src={phpIcon} alt="PHP" />
  </ScrollAnimation>
</div>

<div className="hability">
  <ScrollAnimation animateIn="fadeInUp">
    <img src={reactIcon} alt="React" />
  </ScrollAnimation>
</div>

<div className="hability">
  <ScrollAnimation animateIn="fadeInUp">
    <img src={flutterIcon} alt="Flutter" />
  </ScrollAnimation>
</div>

<div className="hability">
  <ScrollAnimation animateIn="fadeInUp">
    <img src={gitIcon} alt="Git" />
  </ScrollAnimation>
</div>

<div className="hability">
  <ScrollAnimation animateIn="fadeInUp" >
    <img src={figmaIcon} alt="Figma" />
  </ScrollAnimation>
</div>

<div className="hability">
  <ScrollAnimation animateIn="fadeInUp">
    <img src={firebaseIcon} alt="Firebase" />
  </ScrollAnimation>
</div>
</div>
</div>
<div className="about-image">
<ScrollAnimation animateIn="fadeInRight" delay={0.6 * 1000}>
<img
  className="image-fluid"
  src={AboutMe}
  alt=""
/>
</ScrollAnimation>
      </div>
    </Container>
  );
}
